import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`mask-line ${className}`}>
    <motion.span
      style={{ display: "block" }}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "center" }) => (
  <Reveal className={`mb-12 ${align === "center" ? "text-center" : "text-left"}`}>
    {eyebrow && (
      <p className="font-display text-sm tracking-[0.4em] uppercase text-[#F0C971] mb-3">{eyebrow}</p>
    )}
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase neon leading-none">{title}</h2>
    {sub && <p className="mt-4 text-[#9db8d6] max-w-2xl mx-auto text-base md:text-lg">{sub}</p>}
  </Reveal>
);

export const Sparkles = ({ count = 14 }) => {
  const dots = Array.from({ length: count }, (_, i) => ({
    left: `${(i * 73) % 100}%`,
    top: `${(i * 37 + 13) % 100}%`,
    size: 3 + ((i * 7) % 6),
    dur: `${2.4 + (i % 5) * 0.7}s`,
    delay: `${(i % 7) * 0.5}s`,
  }));
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {dots.map((d, i) => (
        <span
          key={i}
          className="sparkle"
          style={{ left: d.left, top: d.top, width: d.size, height: d.size, "--dur": d.dur, "--delay": d.delay }}
        />
      ))}
    </div>
  );
};

export const PerBadge = ({ children }) => (
  <span
    className="inline-flex items-center gap-1 font-display text-xs tracking-[0.2em] uppercase px-3 py-1 rounded-full border"
    style={{
      borderColor: "var(--neon-soft)",
      color: "var(--neon)",
      background: "color-mix(in srgb, var(--neon) 10%, transparent)",
      boxShadow: "0 0 14px color-mix(in srgb, var(--neon) 25%, transparent)",
    }}
  >
    {children}
  </span>
);
